import { SiteLimitForNetAvailability } from 'src/net-availability/types';
import {
  AssetNamesError,
  checkAssetNames,
} from 'src/net-availability/utils/asset-names';
import { BaseError } from 'src/types/base-error';
import { Result } from 'src/types/result';
import { getErrorResult, getResult } from 'src/utils/result/utils';

export class NoSiteLimitsError extends BaseError {
  constructor() {
    super('No SiteLimits found');
  }
}

export class MultipleSiteLimitsError extends BaseError {
  constructor(siteLimits: SiteLimitForNetAvailability[]) {
    super(`Multiple SiteLimits found.`, {
      context: JSON.stringify(siteLimits),
    });
  }
}

export type CheckAssetNamesAndSiteLimitsError =
  AssetNamesError | NoSiteLimitsError | MultipleSiteLimitsError;

export const checkAssetNamesAndSiteLimits = ({
  assetNames,
  siteLimits,
}: {
  assetNames: string[];
  siteLimits: SiteLimitForNetAvailability[];
}): Result<CheckAssetNamesAndSiteLimitsError, SiteLimitForNetAvailability> =>
  checkAssetNames(assetNames).flatMap(() => {
    if (siteLimits.length === 0) {
      return getErrorResult(new NoSiteLimitsError());
    }

    if (siteLimits.length > 1) {
      return getErrorResult(new MultipleSiteLimitsError(siteLimits));
    }

    return getResult(siteLimits[0]!);
  });
